var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _this = this;
import React, { useState } from 'react';
import { Autocomplete } from '@homeexchange/design';
import i18n from '../../../../i18n';
import AutocompleteService from '../../../../utils/AutocompleteService';
import Utils from '../../../../utils/utils';
import { PLACE_LAYERS } from '../../../../constants';
import styles from './reverseSearch.module.scss';
var debounce = function (func, wait) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new Promise(function (resolve) {
            var later = function () {
                timeout = null;
                resolve(func.apply(_this, args));
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        });
    };
};
var setReverseSearchAdminLevel = function () {
    if (PLACE_LAYERS.includes('macroregion')) {
        return 'county';
    }
    return 'macroregion';
};
var getFormattedResults = function (suggestions) {
    var result = {};
    suggestions.forEach(function (item) {
        result[item.formatedTitle] = item;
    });
    return result;
};
var getSuggestionsFromResults = function (results) {
    var sufix = 0;
    if (!results) {
        return null;
    }
    return Object.keys(results).map(function (item) {
        sufix++;
        return { value: item, id: sufix };
    });
};
var getPredictions = debounce(AutocompleteService.getPlaceSuggestions, 500);
export var ReverseSearch = function (_a) {
    var onChange = _a.onChange, filters = _a.filters;
    var _b = useState(null), predictions = _b[0], setPredictions = _b[1];
    var onInputChange = function (value) {
        if (value !== '') {
            getPredictions(value)
                .then(function (predictions) {
                setPredictions(getFormattedResults(predictions));
            })
                .catch(function (error) {
                console.error('Error fetching predictions:', error);
            });
        }
        else {
            setPredictions(null);
        }
    };
    var onItemSelect = function (value) {
        var selectedPrediction = predictions[value];
        var bbox = selectedPrediction.bbox, layer = selectedPrediction.properties.layer;
        var currentFilters = JSON.parse(JSON.stringify(filters));
        var bounds = Utils.convertBboxToBounds(bbox);
        if (selectedPrediction) {
            var updatedFilters = __assign(__assign({}, currentFilters), { preferred_destination: {
                    bounds: bounds,
                    admin_level: layer === 'region' ? setReverseSearchAdminLevel() : layer
                } });
            onChange(updatedFilters, false);
        }
        else if ('preferred_destination' in currentFilters) {
            delete currentFilters.preferred_destination;
            onChange(currentFilters, false);
        }
    };
    return (React.createElement("div", { className: styles['container'] },
        React.createElement("div", { className: styles['description'] }, i18n.t('search:filter.reverse_description')),
        React.createElement(Autocomplete, { suggestions: getSuggestionsFromResults(predictions) || [], onChange: onInputChange, onSelect: onItemSelect, noSuggestionText: i18n.t('common:no_result'), inputIcon: "search-location-pin", itemsIcon: "search-location-pin" })));
};
